import React from 'react';
import './PrintableForm.css';

const VaccinationRecord: React.FC = () => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="printable-form-container">
      <div className="no-print actions-bar">
        <button onClick={() => window.history.back()} className="back-btn">← Back to Forms</button>
        <button onClick={handlePrint} className="print-btn">🖨️ Print / Save as PDF</button>
      </div>

      <div className="printable-form">
        <div className="form-header">
          <h1>The Pet Nanny of Weston</h1>
          <p className="tagline">Licensed • Bonded • Insured</p>
          <p className="contact">thepetnannyofweston@gmail.com</p>
        </div>

        <h2 className="form-title">Pet Vaccination Record</h2>

        <div className="form-section">
          <h3>Pet Owner Information</h3>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Owner Name:</label>
              <input type="text" />
            </div>
            <div className="form-field half-width">
              <label>Phone Number:</label>
              <input type="tel" />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Pet Information</h3>
          <div className="form-row">
            <div className="form-field third-width">
              <label>Pet's Name:</label>
              <input type="text" />
            </div>
            <div className="form-field third-width">
              <label>Species:</label>
              <input type="text" placeholder="Dog / Cat" />
            </div>
            <div className="form-field third-width">
              <label>Breed:</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field third-width">
              <label>Age:</label>
              <input type="text" />
            </div>
            <div className="form-field third-width">
              <label>Gender:</label>
              <input type="text" />
            </div>
            <div className="form-field third-width">
              <label>Weight:</label>
              <input type="text" />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Veterinary Clinic Information</h3>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Veterinary Clinic Name:</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Veterinarian Name:</label>
              <input type="text" />
            </div>
            <div className="form-field half-width">
              <label>Phone Number:</label>
              <input type="tel" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Address:</label>
              <input type="text" />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Vaccination Records - Dogs</h3>
          <p className="section-note">Please complete all applicable vaccinations for dogs</p>
          
          <table className="form-table">
            <thead>
              <tr>
                <th style={{width: '30%'}}>Vaccine Name</th>
                <th style={{width: '20%'}}>Date Given</th>
                <th style={{width: '20%'}}>Expiration Date</th>
                <th style={{width: '30%'}}>Veterinarian/Clinic</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Rabies</strong> (Required)</td>
                <td><input type="date" /></td>
                <td><input type="date" /></td>
                <td><input type="text" /></td>
              </tr>
              <tr>
                <td><strong>DHPP/DAPP</strong><br/><span style={{fontSize: '0.85rem'}}>(Distemper, Hepatitis, Parvo, Parainfluenza)</span></td>
                <td><input type="date" /></td>
                <td><input type="date" /></td>
                <td><input type="text" /></td>
              </tr>
              <tr>
                <td><strong>Bordetella</strong><br/><span style={{fontSize: '0.85rem'}}>(Kennel Cough - Required, must be within 6 months)</span></td>
                <td><input type="date" /></td>
                <td><input type="date" /></td>
                <td><input type="text" /></td>
              </tr>
              <tr>
                <td><strong>Canine Influenza</strong><br/><span style={{fontSize: '0.85rem'}}>(Recommended)</span></td>
                <td><input type="date" /></td>
                <td><input type="date" /></td>
                <td><input type="text" /></td>
              </tr>
              <tr>
                <td><strong>Leptospirosis</strong><br/><span style={{fontSize: '0.85rem'}}>(If applicable)</span></td>
                <td><input type="date" /></td>
                <td><input type="date" /></td>
                <td><input type="text" /></td>
              </tr>
              <tr>
                <td><strong>Other:</strong><input type="text" style={{border: 'none', borderBottom: '1px solid #ccc'}} /></td>
                <td><input type="date" /></td>
                <td><input type="date" /></td>
                <td><input type="text" /></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="form-section">
          <h3>Vaccination Records - Cats</h3>
          <p className="section-note">Please complete all applicable vaccinations for cats</p>
          
          <table className="form-table">
            <thead>
              <tr>
                <th style={{width: '30%'}}>Vaccine Name</th>
                <th style={{width: '20%'}}>Date Given</th>
                <th style={{width: '20%'}}>Expiration Date</th>
                <th style={{width: '30%'}}>Veterinarian/Clinic</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Rabies</strong> (Required)</td>
                <td><input type="date" /></td>
                <td><input type="date" /></td>
                <td><input type="text" /></td>
              </tr>
              <tr>
                <td><strong>FVRCP</strong><br/><span style={{fontSize: '0.85rem'}}>(Feline Viral Rhinotracheitis, Calicivirus, Panleukopenia)</span></td>
                <td><input type="date" /></td>
                <td><input type="date" /></td>
                <td><input type="text" /></td>
              </tr>
              <tr>
                <td><strong>FeLV</strong><br/><span style={{fontSize: '0.85rem'}}>(Feline Leukemia - Required for outdoor cats)</span></td>
                <td><input type="date" /></td>
                <td><input type="date" /></td>
                <td><input type="text" /></td>
              </tr>
              <tr>
                <td><strong>Other:</strong><input type="text" style={{border: 'none', borderBottom: '1px solid #ccc'}} /></td>
                <td><input type="date" /></td>
                <td><input type="date" /></td>
                <td><input type="text" /></td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="form-section">
          <h3>Parasite Prevention</h3>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Flea/Tick Prevention (Product Name & Last Application Date):</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Heartworm Prevention (Product Name & Last Application Date):</label>
              <input type="text" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Last Heartworm Test Date (Dogs):</label>
              <input type="date" />
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Additional Health Information</h3>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Any recent health concerns or veterinary visits:</label>
              <textarea rows={3}></textarea>
            </div>
          </div>
        </div>

        <div className="form-section signature-section">
          <h3>Veterinary Verification</h3>
          <p className="section-note">
            To be completed by veterinarian or attach official vaccination records/certificates
          </p>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Veterinarian Signature:</label>
              <div className="signature-line"></div>
            </div>
            <div className="form-field half-width">
              <label>Date:</label>
              <input type="date" />
            </div>
          </div>
          <div className="form-row">
            <div className="form-field full-width">
              <label>Clinic Stamp/Seal:</label>
              <div style={{border: '2px dashed #ccc', height: '80px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999', marginTop: '0.5rem'}}>
                Place Clinic Stamp Here
              </div>
            </div>
          </div>
        </div>

        <div className="form-section signature-section">
          <h3>Owner Certification</h3>
          <div className="checkbox-group" style={{marginBottom: '1rem'}}>
            <input type="checkbox" id="cert" />
            <label htmlFor="cert">
              I certify that the above vaccination information is accurate and current. I understand that proof of 
              vaccinations may be required and I will provide documentation from my veterinarian.
            </label>
          </div>
          <div className="form-row">
            <div className="form-field half-width">
              <label>Owner Signature:</label>
              <div className="signature-line"></div>
            </div>
            <div className="form-field half-width">
              <label>Date:</label>
              <input type="date" />
            </div>
          </div>
        </div>

        <div className="form-footer">
          <p>Page 1 of 1</p>
          <p>The Pet Nanny of Weston • thepetnannyofweston@gmail.com</p>
          <p style={{marginTop: '0.5rem', fontSize: '0.8rem'}}>
            Note: Please attach copies of official vaccination certificates from your veterinarian
          </p>
        </div>
      </div>
    </div>
  );
};

export default VaccinationRecord;
